import { iconA11y, type IconProps } from './iconProps';

export function MagnifierIcon({ size = 14, title, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
      className={className}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <rect
        x="14.0366"
        y="12.5677"
        width="2"
        height="6.79822"
        transform="rotate(135 14.0366 12.5677)"
        fill="currentColor"
      />
      <circle
        cx="5.65137"
        cy="5.65137"
        r="4.65137"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
